module.exports = __webpack_public_path__ + "img/ASCH.1de52d8e.png";